"use client";

import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./PropertySlider.css";

const truncateTitle = (title, wordLimit = 4) => {
  const words = title.split(" ");
  return words.length > wordLimit ? words.slice(0, wordLimit).join(" ") + "..." : title;
};

const decodeHtmlEntities = (html) => {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
};

const SampleNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", right: "-45px" }}
      onClick={onClick}
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 18L15 12L9 6" stroke="#104b97" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
  );
};

const SamplePrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", left: "-45px" }}
      onClick={onClick}
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 18L9 12L15 6" stroke="#104b97" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
  );
};

const PropertySlider = () => {
  const navigate = useNavigate();
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    const fetchProperties = async () => {
      try {
      const res = await fetch(`https://pp-backend-1-sa8p.onrender.com/properties`);
        const data = await res.json();

        if (!Array.isArray(data)) {
          console.error("Expected an array of properties but got:", data);
          return;
        }

        setProperties(data.slice(0, 4));
      } catch (err) {
        console.error("Error fetching properties:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProperties();
  }, []);

  const displayedProperties = showAll ? properties : properties.slice(0, 4);

  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      { 
        breakpoint: 1024, 
        settings: { 
          slidesToShow: 3,
          nextArrow: <SampleNextArrow />,
          prevArrow: <SamplePrevArrow />
        } 
      },
      { 
        breakpoint: 768, 
        settings: { 
          slidesToShow: 2,
          nextArrow: <SampleNextArrow />,
          prevArrow: <SamplePrevArrow />
        } 
      },
      { 
        breakpoint: 600, 
        settings: { 
          slidesToShow: 1,
          arrows: false
        } 
      },
    ],
  };

  if (loading) return <p>Loading properties...</p>;

  return (
    <div className="property-slider-container">
      <div className="property-slider">
        <Slider {...settings}>
          {displayedProperties.map((property) => (
            <div key={property._id} className="property-card-wrapper">
              <div className="property-card">
                <a href={`/property/${property.slug || property._id}`} target="_blank" rel="noopener noreferrer">
                  <img
                    src={property.propertyImages?.[0]?.url || "https://via.placeholder.com/400"}
                    alt={property.title}
                    className="property-image"
                  />
                  <div className="property-details">
                    <h3 className="property-title">{truncateTitle(decodeHtmlEntities(property.title))}</h3>
                    <div className="property-meta">
                      <p className="property-size">
                        {property.size ? `${property.size} sq. ft.` : "Size not available"}
                      </p>
                      <p className="property-possession">
                        {property.possessionDate ? `Possession: ${property.possessionDate}` : "Possession not available"}
                      </p>
                    </div>
                  </div>
                  <div className="property-footer">
                    <p className="property-price">
                      {property.price ? `₹ ${property.price} ${property.propertyLabel || ""}` : "Price on request"}
                    </p>
                    <button className="contact-now-button">Contact Now</button>
                  </div>
                </a>
              </div>
            </div>
          ))}
          {!showAll && (
            <div className="property-card-wrapper view-more-card">
              <button className="view-more-button" onClick={() => navigate('/property-cards')}>
                View More →
              </button>
            </div>
          )}
        </Slider>
      </div>
    </div>
  );
};

export default PropertySlider;